import { Card2 } from "@/ui2/atoms/Card";
import { Heading2 } from "@/ui2/atoms/Heading";

import { CustomerSuccessTabs } from "./CustomerSuccessTabs";

export function CustomerSuccess() {
  return (
    <Card2 as="section" className="tw:mx-auto tw:w-full tw:flex-col tw:gap-4">
      <Heading2 as="h1" className="tw:px-6 tw:pt-6" size={3}>
        Customer Success
      </Heading2>

      <CustomerSuccessTabs />
    </Card2>
  );
}
